//funzione per la creazione del drawer per l'aggiunta layer
import React from 'react';
import AddLayerList from '../AddLayer/AddLayerList'
import layerImage from './Addlayer.svg'
import CloseIcon from '@material-ui/icons/Close';
import TabAddLayer from './AggiungiLayer'
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import axios from 'axios'
var XMLParser = require('react-xml-parser');
const wmsService = (paths) =>{
    const json = new XMLParser().parseFromString(paths, "text/xml");
    const capability = json.getElementsByTagName("Capability")
    const  serviceLayer = capability[0].getElementsByTagName("Layer") 
    return serviceLayer
}
const wfsService = (paths) =>{
    const json = new XMLParser().parseFromString(paths, "text/xml");
    
    const capability = json.getElementsByTagName("FeatureTypeList")
    const  serviceLayer = capability[0].getElementsByTagName("FeatureType") 
    return serviceLayer
}
export default function AddLayerComponent(props) {
const [dataArray,setDataArray] = React.useState({url:'',data:[]})
    useTranslation()
    const getLayer = (url,type) =>{
        setDataArray({url:'',data:[]})
        if(url === null){
            setDataArray({url:'',data:[]})


        }else{
            
            //axios.post(process.env.REACT_APP_PROVA_URL_MARIO,{url: url})
            //axios.post(process.env.REACT_APP_PRODUZIONE_ADD_LAYER,{url: url})
            axios.post(`${window.configFile.httpProxy.urlAddLayer}`,{url: url,headers: window.tp_headers})
            .then(response => { 
                
                const paths = response.data
                 setDataArray({url:url.replaceAll('&request=GetCapabilities',''),data:type==='WMS'?wmsService(paths):wfsService(paths)})
            })
            .catch(error=>{})

        
    /*  axios.get(url.replaceAll('&request=GetCapabilities','') + "&request=GetCapabilities",{typename: 'workspace:layer_name'})
        .then(response => {
            
            const paths = response.data
             setDataArray({url:url.replaceAll('&request=GetCapabilities',''),data:type==='WMS'?wmsService(paths):wfsService(paths)})
        })
        .catch(error=>{}) */ 
    }}
  return (
        <div className={"lateraltDiv"}>
            <div className={"title"}>
                <img src={layerImage} alt="Calcolo" className={"tocImage"}></img><Trans>AGGIUNGI LAYER</Trans> <button className={"buttonClose"} onClick={props.callback}><CloseIcon/></button>
            </div>
            <div className={"addLayerDiv"}>
                <TabAddLayer callback={getLayer.bind(this)}/>
            </div>
            <AddLayerList data={dataArray }/>

        </div>

  );
}